import * as React from 'react';
import { Dropdown } from '../../Dropdown/dropdown';
import { Op } from '../../../enums/Op';
import { Arrow } from 'rcd-cpp-ui/ui/icon/Arrow';
import { cn } from '../../../utils';
import { View } from '../../../types/View';
import { FieldKey } from '../../../enums/FieldKey';

interface Props {
  options: Op[];
  selected: Op;
  onSelect: (o: Op) => void;
  disabled?: boolean;
}

const OpLabel: { [x in Op]: string } = {
  and: 'and',
  or: 'or',
  is: 'is',
  isNot: 'is not',
  contains: 'contains',
  doesNotContain: 'does not contain',
  startsWith: 'starts with',
  endsWith: 'ends with',
  isEmpty: 'is empty',
  isNotEmpty: 'is not empty',
  equals: 'equals',
  greaterThan: 'greater than',
  lessThan: 'less than',
  between: 'between',
  P7D: 'in next 7 days',
  P30D: 'in next 30 days',
  P90D: 'in next 90 days',
  relative: 'relative range',
  refIds: 'is',
  notRefIds: 'is not',
  multiValue: 'multi-value'
};

export const getLabel = (o: Op | string, filter?: View.FiltersField) => {
  if (filter?.field == FieldKey.ItemEmployeeRelationType) {
    return 'includes';
  }
  const ops = Object.entries(OpLabel);
  for (const [k, v] of ops) {
    if (o == k) return v;
  }
  for (const [k, v] of ops) {
    if (o == v) return v;
  }
  return o;
};

export const Options = ({ disabled, options, selected, onSelect }: Props) => {
  return (
    <Dropdown
      disabled={disabled}
      options={options}
      renderOption={getLabel}
      onSelect={onSelect}
      selected={selected}
    >
      <div className={cn('operator', { 'disabled-dropdown': disabled })}>
        {getLabel(selected)}
        {!disabled && <Arrow direction="down" type="line" />}
      </div>
    </Dropdown>
  );
};
